import React from "react";

const ModalFooterRight = ({ children }) => {
    return <div className="Modal2-footer--right">{children}</div>;
};
export default ModalFooterRight;
